import React, { useEffect, useState, useContext } from "react";
import "../../App.css";
import { Navigate, useNavigate } from "react-router-dom";
import Sidebar from "./sidebar";
import SignupModal from "../login/signup";
import logo from "../img/logo.png";
import Dashboard from "./dashboard.js/dashboardscreen";

import { useLocation } from "react-router-dom";
import UserFeedback from "../login/userfeedback";
import UserComplain from "../login/usercomplain";

const MainScreen = () => {
  const location = useLocation();

  const isAuthenticated = localStorage.getItem("userAuthentication");
  const queryParams = new URLSearchParams(location.search);
  const userfeedback = queryParams.get("id");
  const usercomplain = queryParams.get("id");

  return isAuthenticated ? (
    <div className="w-full h-screen">
      {/* Main Content */}
      <Dashboard />
    </div>
  ) : (
    // userfeedback ? (
    //   <div className="w-full h-screen">
    //    <UserFeedback />
    //    </div>) :
    //    usercomplain ? (
    //     <div className="w-full h-screen">
    //      <UserComplain />
    //      </div>) :
    //         (

    <Navigate to="/login" replace />
    // )
  );
};

export default MainScreen;
